import { render, staticRenderFns } from "./Sidebar_Collapse.vue?vue&type=template&id=9abde2fc&scoped=true&"
import script from "./Sidebar_Collapse.vue?vue&type=script&lang=js&"
export * from "./Sidebar_Collapse.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar_Collapse.vue?vue&type=style&index=0&id=9abde2fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9abde2fc",
  null
  
)

export default component.exports